export const MAX_CYBER_IQ_POINTS = 10000;
